import { render } from "./Form.vue?vue&type=template&id=4eddc92c"
import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/form/Form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4eddc92c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4eddc92c', __exports__)) {
    api.reload('4eddc92c', __exports__)
  }
  
  module.hot.accept("./Form.vue?vue&type=template&id=4eddc92c", () => {
    api.rerender('4eddc92c', render)
  })

}


export default __exports__